import styles from './css/gradientbar.module.css';

export default function Gradientbar(props) {
    var min = (props.min) ? props.min : 0;
    var max = (props.max) ? props.max : 1;
    var val = (props.value != null) ? (props.value - min) / (max - min) : null;
    if ( val != null && val > 1 ) val = 1;
    return (
        <div className={styles.bar}>
            {
                (val != null) ? <div style={{color:"#6e6e6e", position:"relative",left:"calc((100% - 1em) * " + val + ")"}}>◆</div>
                    : <div style={{background:"white",textAlign:"center"}}>未判定</div>
            }
        </div>
    )
}
